// Mock data for PrismoSpark Restaurant Growth Platform

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    restaurant: "American Pizzeria",
    location: "Punjab, India",
    rating: 5,
    text: "Isabella is like having an extra staff member who never sleeps. We're now booked solid Friday-Sunday. From invisible to fully booked weekends in 90 days.",
    revenue_increase: "32%",
    review_increase: "63 reviews",
    bookings_before: "12/week",
    bookings_after: "47/week"
  },
  {
    id: 2,
    name: "Suraj",
    restaurant: "Madras Leaf",
    location: "Punjab, India", 
    rating: 5,
    text: "The new website looks incredible, but reputation management saved us. We went from drowning in bad reviews to thriving with a 4.6★ rating.",
    revenue_increase: "65%",
    review_increase: "89 reviews",
    rating_before: "3.9★",
    rating_after: "4.6★"
  },
  {
    id: 3,
    name: "Preet Singh",
    restaurant: "Mario's Pizzeria",
    location: "Khanna, India",
    rating: 5,
    text: "43 new 5-star reviews in just 2 months. Isabella handles both Hindi and Punjabi perfectly. Our weekend revenue increased by 23%.",
    revenue_increase: "32%", 
    review_increase: "43 reviews",
    bookings_after: "89 reservations/month"
  }
];

export const features = [
  {
    id: 1,
    title: "Premium Website Built to Convert",
    description: "Mobile-first design with fast loading speeds and direct booking integration",
    benefits: ["3× higher conversion rate", "Integrated booking platforms", "Interactive menu filters", "Mobile-optimized design", "Fast loading speeds"],
    icon: "Globe"
  },
  {
    id: 2,
    title: "Isabella AI: Your 24/7 Digital Host",
    description: "Brand-named AI assistant handling reservations, answers, and multilingual support",
    benefits: ["24/7 availability", "Multi-language support", "38 after-hours bookings avg", "Smart handoffs to staff", "Never misses opportunities"],
    icon: "Bot"
  },
  {
    id: 3,
    title: "Review Accelerator System",
    description: "10× more 5-star reviews with automated collection and AI responses",
    benefits: ["10-15 reviews monthly", "AI-drafted responses", "Unified monitoring", "Rating improvement", "Automatic follow-ups"],
    icon: "Star"
  },
  {
    id: 4,
    title: "Local SEO Engine",
    description: "Own the 'near me' searches with advanced local optimization",
    benefits: ["Google Business optimization", "Local content targeting", "Citation consistency", "Competitor tracking", "Schema markup"],
    icon: "Search"
  },
  {
    id: 5,
    title: "Growth Command Center",
    description: "All your key metrics in one unified dashboard",
    benefits: ["Website traffic breakdown", "Multi-channel reservations", "Review trend tracking", "Automated reports", "Real-time data"],
    icon: "BarChart3"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: 199,
    period: "month",
    description: "Perfect for small restaurants starting their digital transformation",
    features: [
      "Professional website design",
      "Isabella AI assistant (basic)",
      "Review management system",
      "Local SEO basics",
      "Growth dashboard",
      "Email support",
      "1 location"
    ],
    notIncluded: [
      "Advanced Isabella features",
      "Premium SEO optimization",
      "Phone support",
      "Multi-location support"
    ],
    popular: false,
    cta: "Start 30-Day Trial"
  },
  {
    id: 2,
    name: "Growth",
    price: 399,
    period: "month", 
    description: "Complete PrismoSpark system for serious restaurant growth",
    features: [
      "Everything in Starter",
      "Advanced Isabella AI (multilingual)",
      "Automated review responses",
      "Complete SEO optimization", 
      "Priority phone support",
      "Up to 3 locations",
      "Custom integrations",
      "Advanced analytics"
    ],
    notIncluded: [
      "Unlimited locations",
      "White-label solutions"
    ],
    popular: true,
    cta: "Start 30-Day Trial"
  },
  {
    id: 3,
    name: "Enterprise",
    price: 799,
    period: "month",
    description: "Full-scale solution for restaurant chains and franchise operations",
    features: [
      "Everything in Growth",
      "Unlimited locations",
      "White-label dashboard",
      "Custom Isabella training",
      "Dedicated account manager",
      "24/7 priority support",
      "API access",
      "Custom development"
    ],
    notIncluded: [],
    popular: false,
    cta: "Schedule Consultation"
  }
];

export const faqData = [
  {
    category: "Getting Started",
    questions: [
      {
        question: "How quickly can I see results?",
        answer: "Most restaurants see immediate improvements in website performance and start capturing after-hours reservations within 24 hours. Review collection begins within 2 hours of setup. SEO improvements show in 2-4 weeks with significant gains in 60-90 days."
      },
      {
        question: "What's included in the setup?", 
        answer: "Complete website design, Isabella AI configuration for your brand, review system setup, Google Business optimization, and full staff training. Everything is done for you - no technical knowledge required."
      },
      {
        question: "Do I really get a 30-day money-back guarantee?",
        answer: "Yes, absolutely. Try PrismoSpark for 30 days. If you don't see measurable results in bookings, reviews, or search visibility, we'll refund every penny. No questions asked."
      }
    ]
  },
  {
    category: "Isabella AI Features",
    questions: [
      {
        question: "How does Isabella handle different languages?",
        answer: "Isabella is fluent in English, Spanish, French, Hindi, Punjabi, and Mandarin. She automatically detects the customer's language and responds naturally. Perfect for diverse communities and tourist areas."
      },
      {
        question: "Can Isabella integrate with my current reservation system?",
        answer: "Yes! Isabella works seamlessly with OpenTable, Resy, Toast, Square, and all major booking platforms. She can also work with your existing phone system and website forms."
      },
      {
        question: "What happens if Isabella can't answer something?",
        answer: "Isabella smoothly hands off complex requests to your staff with full conversation context. Your team gets all the details - no repeated questions or lost information."
      }
    ]
  },
  {
    category: "Results & ROI",
    questions: [
      {
        question: "How many extra bookings can I expect?",
        answer: "Based on our restaurant data: 15-20 after-hours reservations monthly, 34% average booking increase in 90 days, and 70% improvement in 'near me' search visibility. Results vary by location and competition."
      },
      {
        question: "How quickly will my reviews improve?",
        answer: "Most restaurants go from 1-2 reviews monthly to 10-15 reviews monthly within 60 days. Average rating improvements of 0.5-1.5 stars within 6 months, depending on starting point."
      },
      {
        question: "What's the typical ROI?",
        answer: "Average restaurant sees $18,000+ additional monthly revenue within 90 days. With plans starting at $199/month, most see 10:1 ROI or better. Every additional reservation covers the monthly cost."
      }
    ]
  }
];

export const caseStudies = [
  {
    id: 1,
    restaurant: "American Pizzeria",
    location: "Punjab, India", 
    cuisine: "Pizza & Italian",
    owner: "Rajesh Kumar",
    challenge: "New restaurant with no online presence, competing against 15 established pizza chains nearby",
    solution: "Complete PrismoSpark system: premium website, Isabella AI, review acceleration, and aggressive local SEO",
    results: {
      timeline: "90 days",
      reservations_before: "12/week",
      reservations_after: "47/week", 
      revenue_increase: "$18,000/month",
      review_count: "63 new reviews",
      review_rating: "4.8★ average",
      seo_ranking: "First page for 'pizza chains Punjab'",
      after_hours_bookings: "38 captured by Isabella"
    },
    testimonial: "Isabella is like having an extra staff member who never sleeps. We're now booked solid Friday-Sunday.",
    image: "/api/placeholder/400/300"
  },
  {
    id: 2,
    restaurant: "Madras Leaf",
    location: "Punjab, India",
    cuisine: "South Indian",
    owner: "Suraj",
    challenge: "8-year-old restaurant with broken mobile site, 3.9★ rating, lunch reservations down 40% year-over-year",
    solution: "Complete reputation overhaul with new mobile-first website, automated review management, and local SEO recovery",
    results: {
      timeline: "6 months", 
      rating_before: "3.9★",
      rating_after: "4.6★",
      review_count: "89 new positive reviews",
      lunch_bookings: "+65% vs previous year",
      mobile_traffic: "87% (vs 43% before)",
      seo_ranking: "First page for 'best dosa Punjab'"
    },
    testimonial: "The new website looks incredible, but reputation management saved us. We went from drowning in bad reviews to thriving.",
    image: "/api/placeholder/400/300"
  }
];

export const quickWins = [
  {
    restaurant: "Mario's Pizzeria",
    location: "Khanna, India",
    result: "43 new 5-star reviews in 2 months • Revenue up 32%"
  },
  {
    restaurant: "Mumbai Spice House", 
    location: "Ludhiana, India",
    result: "Isabella handles Hindi/Punjabi perfectly • 89 reservations first month"
  },
  {
    restaurant: "Green Leaf Café",
    location: "Delhi, India", 
    result: "From page 3 to first page on Google • Traffic up 340%"
  },
  {
    restaurant: "Bay Cafe",
    location: "Amritsar, India",
    result: "Late-night Isabella bookings increased weekend revenue 23%"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Three Leaks Draining Your Restaurant Revenue (And How to Fix Them)",
    excerpt: "Discover the hidden profit killers costing restaurants thousands monthly and the simple fixes that work.",
    readTime: "5 min read",
    category: "Revenue Growth", 
    publishDate: "2024-01-15"
  },
  {
    id: 2,
    title: "Why Your Restaurant Needs Isabella AI (Real Results Inside)",
    excerpt: "See how 24/7 AI assistance is capturing 40+ extra reservations monthly for smart restaurant owners.",
    readTime: "7 min read",
    category: "AI Technology",
    publishDate: "2024-01-10"
  },
  {
    id: 3,
    title: "From 3.9★ to 4.6★: The Review Recovery Playbook",
    excerpt: "Step-by-step guide to transforming your online reputation and winning back customer trust.",
    readTime: "10 min read", 
    category: "Reputation Management",
    publishDate: "2024-01-05"
  }
];

export const companyInfo = {
  mission: "Helping restaurants dominate their local market through premium technology and proven growth systems.",
  story: "Founded by restaurant industry veterans who experienced firsthand the frustration of losing customers to competitors with better digital presence. We built the complete solution we wished we had.",
  values: [
    "Results over promises - every feature must drive measurable growth",
    "Restaurant-first design - built by people who understand the business", 
    "Transparent pricing with 30-day money-back guarantee",
    "Premium technology accessible to independent restaurants"
  ],
  team: {
    size: "25+ restaurant and technology experts",
    locations: "Toronto, Mumbai, Delhi",
    experience: "200+ restaurants transformed across 3 countries"
  }
};

export const trustBadges = [
  "SOC 2 Compliant",
  "GDPR Compliant",
  "PCI DSS Certified", 
  "ISO 27001 Certified"
];

export const clientLogos = [
  "American Pizzeria",
  "Madras Leaf", 
  "Mario's Pizzeria",
  "Mumbai Spice House",
  "Green Leaf Café",
  "Bay Cafe"
];